const isFieldRequired = (field, requiredFields) => {
  if (!requiredFields || !requiredFields.length) {
    return false;
  }
  return requiredFields.includes(field);
};

export const isFieldRequiredEntity = (field, requiredFields) => {
  if (!requiredFields || !requiredFields.campos) {
    return false;
  }
  return isFieldRequired(field, requiredFields.campos);
};

export const isFieldRequiredEntityItens = (field, requiredFields) => {
  if (!requiredFields || !requiredFields.camposItens) {
    return false;
  }
  return isFieldRequired(field, requiredFields.camposItens);
};
